const appConfig = {
  baseUrl: new URL(location.href).origin + '/',
  voxAppDomain: 'tm-vue.novikov.n4.voximplant.com', //
  baseServerUrl: 'https://dev.api.renova.world/', // TODO сделать настраиваемым параметром
  baseAuthRedirectUrl: 'https://accounts.google.com/o/oauth2/v2/auth', //
  clientId: '444550250921-p087s2j094j29sabd1dl8frgc0bi7bc5.apps.googleusercontent.com', //
};
export default appConfig;
